import React, { useEffect, useState } from "react";
import { Card, Form, Nav, NavItem, NavLink } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";

import { useRequest } from "@components/AppHook";
import { DevForm } from "@components/Forms/Fields";
import { buildFormData } from "@components/Forms/Handlers";
import { RenderForm } from "@components/Forms/Render";
import { DefaultLayout } from "@components/Layouts";
import { getEventSubmitter, scroll_to_top, url_reverse } from "@components/Utils";

export default function EventSelectionItemEditScreen() {
    const { t } = useTranslation();
    const [apiData, setApiData] = useState({});
    const { event_slug, selection_slug, item_id, loc } = useParams();
    const { api_get, api_post_formdata } = useRequest();
    const navigate = useNavigate();
    const apiUrl = loc
        ? url_reverse("api:event:selection:item:loc:edit", { event_slug, selection_slug, item_id, loc })
        : url_reverse("api:event:selection:item:edit", { event_slug, selection_slug, item_id });
    useEffect(() => {
        api_get(null, apiUrl, {
            then: (resp) => {
                if (resp.status === "ok") {
                    setApiData(resp);
                }
            },
        });
    }, [apiUrl]);

    const onSubmit = (ev) => {
        ev.preventDefault();
        const formData = buildFormData({
            ev,
            apiData,
            submitPrefixes: ["main"],
        });
        api_post_formdata(ev, apiUrl, formData, {
            then: (resp) => {
                if (resp.status === "ok") {
                    setApiData(resp);
                    const { tn } = getEventSubmitter(ev);
                    if (tn === "save") {
                        navigate(url_reverse("admin:event:items", { slug: event_slug }));
                    }
                } else if (resp.status === "fail") {
                    setApiData(resp);
                    scroll_to_top();
                }
            },
        });
    };
    const header = (
        <>
            <Link to={url_reverse("admin:event:items", { slug: event_slug })}>{t("Управление ивентом")}</Link>
            <span> – </span>
        </>
    );
    return (
        <DefaultLayout>
            <Card>
                <Card.Header>
                    {header}
                    {t("Настройка игры")}
                    <div className="dmg-card-header-tools">
                        <Nav
                            variant="tabs"
                            defaultActiveKey="list"
                            activeKey={loc === undefined ? "base" : loc}
                            className="mb-3 mt-2 ml-0"
                        >
                            <NavItem>
                                <NavLink
                                    eventKey="base"
                                    onClick={() =>
                                        navigate(
                                            url_reverse("admin:event:selection:items:edit", {
                                                event_slug,
                                                selection_slug,
                                                item_id,
                                            })
                                        )
                                    }
                                >
                                    {t("Базовая")} {apiData.sfx === "ru" ? "RU" : "EN"}
                                </NavLink>
                            </NavItem>
                            {apiData.locales?.map((el) => {
                                return (
                                    <NavItem key={el}>
                                        <NavLink
                                            eventKey={el}
                                            onClick={() =>
                                                navigate(
                                                    url_reverse("admin:event:selection:items:loc:edit", {
                                                        event_slug,
                                                        selection_slug,
                                                        item_id,
                                                        loc: el,
                                                    })
                                                )
                                            }
                                        >
                                            {el.toUpperCase().slice(-2)}
                                        </NavLink>
                                    </NavItem>
                                );
                            })}
                        </Nav>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Form onSubmit={onSubmit}>
                        <RenderForm apiData={apiData} setApiData={setApiData} bareForm={true} />
                        <DevForm.Button variant="primary" type="submit" name="save">
                            {t("Сохранить")}
                        </DevForm.Button>{" "}
                        <DevForm.Button variant="primary" type="submit" name="save_and_stay">
                            {t("Сохранить и продолжить")}
                        </DevForm.Button>
                    </Form>
                </Card.Body>
            </Card>
        </DefaultLayout>
    );
}
